import { useAuth } from "@/hooks/useAuth";
import Header from "@/components/Header";
import TrailMap from "@/components/TrailMap";
import { Loader2 } from "lucide-react";
import { useTrailSegments } from "@/hooks/useTrails";

const TrailExplorer2 = () => {
  const { isLoading } = useAuth();

  // Data hooks - fetch trail segments for the map
  const { segments } = useTrailSegments();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      <main className="relative h-[calc(100vh-80px)]">
        {/* Full-screen map - unified view showing all data */}
        <TrailMap
          className="h-full w-full"
          segments={segments}
        />
      </main>
    </div>
  );
};

export default TrailExplorer2;